import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { formatDate } from '@atheneum/api/dist/lib'
import DocumentTitle from 'react-document-title'

import ClientProfileActions from './ClientProfileActions'
import ClientEmailActions from './ClientEmailActions'
import Row from '@components/Details/Row'
import { clientRecords } from '@atheneum/api'
import Comments from '@components/Comments'
import CommentStore from '@components/Comments/Comment.store'

class DetailsTab extends Component {
  static propTypes = {
    clientContactStore: PropTypes.object,
    sidebarStore: PropTypes.object,
    match: PropTypes.object
  }

  state = {
    parentAccountName: ''
  }

  componentDidMount () {
    this.getParentAccountName()
  }

  componentDidUpdate () {
    const { contact, getContact } = this.props.clientContactStore
    const url = this.props.match.url
    const urlId = url.substring(url.lastIndexOf('/') + 1)
    if (Number(urlId) !== contact.id) {
      getContact(urlId)
    }
  }

  getParentAccountName () {
    const { contact } = this.props.clientContactStore
    clientRecords.getParentAccount(contact.client.account.parentAccountId).then(res => {
      this.setState({ parentAccountName: res.parentAccountName })
    })
  }

  formatPhoneType = phones => {
    return phones.map(phone => {
      const phoneType =
        phone.phoneType &&
        phone.phoneType.charAt(0).toUpperCase() + phone.phoneType.slice(1)
      const label = phoneType ? `Phone (${phoneType})` : 'Phone'

      return { ...phone, phoneType: phoneType, label }
    })
  }

  handleSidebarClick = (id, template) => {
    this.props.sidebarStore.openSidebar({
      template,
      id
    })
  }

  renderComplianceAuditorSection = companyName => {
    return (
      <div className='m-b-lg'>
        <div className='row'>
          This user is a Compliance auditor responsible for all projects under
          account {companyName}
        </div>
      </div>
    )
  }

  renderKnowledgeManagerSection = (contact, parentAccountName) => {
    return (
      <div className='group'>
        {contact.client.global ? (
          <div>
            <span>Global</span>
            <div className='row'>
              This user is a KM responsible for all accounts under{' '}
              {parentAccountName}
            </div>
          </div>
        ) : (
          contact.kmSpecificAccounts.map(account => {
            return (
              <Row
                noLabel
                text={account.companyName}
                onClick={() =>
                  this.handleSidebarClick(account.id, 'client-account')
                }
              />
            )
          })
        )}
        <Row
          label='Atheneum contact'
          text={
            contact.client.atheneumContact &&
            contact.client.atheneumContact.fullName
          }
        />
      </div>
    )
  }

  render () {
    const { clientContactStore } = this.props
    const { contact, phones } = clientContactStore
    const formattedPhones = this.formatPhoneType(phones)
    const parentAccountName = this.state.parentAccountName
    const commentStore = new CommentStore()

    return (
      <DocumentTitle
        title={`${contact.fullName} - profile | Atheneum Partners`}
      >
        <div className='details-wrapper animate-intro'>
          <ClientProfileActions
            contact={contact}
            clientContactStore={clientContactStore}
            commentStore={commentStore}
          />
          <div className='content'>
            <div className='col-2'>
              <div className='story'>
                <span className='label'>Basic information</span>
                <div className='group-wrapper'>
                  <div className='group'>
                    <Row
                      label='Name in original language'
                      text={contact.originalName}
                    />
                    <Row label='Position' text={contact.client.position} />
                    <Row
                      label='Office'
                      text={contact.client.office.officeName}
                      onClick={() =>
                        this.handleSidebarClick(
                          contact.client.office.id,
                          'client-office'
                        )
                      }
                    />
                    <Row
                      label='Account'
                      text={contact.client.account.companyName}
                      onClick={() =>
                        this.handleSidebarClick(
                          contact.client.account.id,
                          'client-account'
                        )
                      }
                    />
                  </div>
                </div>
              </div>
              {(contact.client.knowledgeManager ||
                contact.client.complianceAuditor) && (
                <div className='story'>
                  <span className='label'>Additional permissions</span>
                  <div className='group-wrapper'>
                    {contact.client.complianceAuditor &&
                      this.renderComplianceAuditorSection(
                        contact.client.account.companyName
                      )}
                    {contact.client.knowledgeManager &&
                      this.renderKnowledgeManagerSection(
                        contact,
                        parentAccountName
                      )}
                  </div>
                </div>
              )}
            </div>
            <div className='col-2 col-2--padding'>
              <div className='story'>
                <span className='label'>Address</span>
                <div className='group-wrapper'>
                  <div className='group'>
                    {phones &&
                      formattedPhones.map(phone => {
                        return (
                          <Row
                            key={phone.id}
                            label={phone.label}
                            text={phone.phoneNum}
                          />
                        )
                      })}
                    <Row
                      label='Email address'
                      text={contact.email}
                      mailTo
                      copiable
                    />
                    {contact.address &&
                      contact.address.emails.length > 0 &&
                      contact.address.emails.map(email => (
                        <Row
                          label='Email address'
                          text={email.email}
                          mailTo
                          copiable
                        />
                      ))}
                    {contact.clientLinks.map((link, index) => {
                      let label = ''
                      if (index === 0) {
                        label = 'Professional profile'
                      }
                      return (
                        <Row
                          key={link.id}
                          label={label}
                          externalLink={link.professionalLinkUrl}
                        />
                      )
                    })}
                    <Row
                      label='Address'
                      text={contact.address && contact.address.address1}
                    />
                    <Row
                      label='Secondary address'
                      text={contact.address && contact.address.address2}
                    />
                    <Row
                      label='City'
                      text={contact.address && contact.address.city}
                    />
                    <Row
                      label='Postal code'
                      text={contact.address && contact.address.postalCode}
                    />
                    <Row
                      label='State/Province'
                      text={contact.address && contact.address.state}
                    />
                    <Row label='Country' text={contact.country} />
                    <Row label={'Timezone'} text={contact.timezone} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='comments-group'>
            <Comments
              commentStore={commentStore}
              modelId={contact.id}
              model='client'
            />
          </div>
          <div className='comments-wrapper'>
            <div className='content'>
              <div className='col-2'>
                <div className='group-wrapper'>
                  <div className='group'>
                    <Row
                      label='Date created'
                      text={formatDate(contact.created_at)}
                    />
                    {contact.lastLogin && (
                      <Row
                        label='Last login'
                        text={formatDate(contact.lastLogin)}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className='col-2 col-2--padding'>
                <div className='invite-action-wrapper'>
                  <ClientEmailActions contact={contact} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('sidebarStore')(observer(DetailsTab))
